import { motion } from 'framer-motion';
import { CalendarDays, ChevronRight, Megaphone } from 'lucide-react';
import { BottomSheet } from '@/components/ui/bottom-sheet';
import { useUiStore } from '@/stores/ui-store';

export function CreateSheet() {
  const open = useUiStore((s) => s.createOpen);
  const close = useUiStore((s) => s.closeCreate);
  const openNewEvent = useUiStore((s) => s.openNewEvent);
  const openNewTask = useUiStore((s) => s.openNewTask);

  return (
    <BottomSheet open={open} onClose={close} hideClose>
      {/* Eyebrow "criar novo" + lista de duas ações */}
      <p className="eyebrow mb-3.5">criar novo</p>
      <div className="flex flex-col gap-2.5">
        <SheetAction
          icon={<CalendarDays className="h-5 w-5" />}
          title="Evento"
          desc="Show, DJ, couvert e promos"
          onClick={openNewEvent}
        />
        <SheetAction
          icon={<Megaphone className="h-5 w-5" />}
          title="Postagem"
          desc="Tarefa de marketing com responsável"
          onClick={openNewTask}
        />
      </div>
    </BottomSheet>
  );
}

function SheetAction({
  icon,
  title,
  desc,
  onClick,
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
  onClick: () => void;
}) {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      whileTap={{ scale: 0.98 }}
      className="flex w-full items-center gap-3.5 rounded-xl border border-border bg-card px-4 py-3.5 text-left transition"
    >
      {/* Caixa de ícone bg-primary-soft text-primary */}
      <span className="grid h-[42px] w-[42px] flex-shrink-0 place-items-center rounded-md bg-primary-soft text-primary">
        {icon}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-[15px] font-semibold text-foreground">{title}</span>
        <span className="mt-0.5 block text-xs text-muted-foreground">{desc}</span>
      </span>
      <ChevronRight className="h-[18px] w-[18px] text-muted-foreground" />
    </motion.button>
  );
}
